<h2>Version</h2>

<pre>
  {{ appVersion }}
</pre>
<hr>
<h2>Config</h2>

<pre>
  {{ config$ | async | json}}
</pre>
<hr>
<h2>Gateway Config</h2>

<pre>
  {{ gatewayConfig$ | async | json}}
</pre>
